import styled from 'styled-components';
import Text from '@components/Text/Text';
import { BActionIcon } from '@components/BActionIcon/BActionIcon';
import { navigationState } from '@store/hookstate';
import { initialNavigationState } from '@store/hookstate/navigation/navigation';
import { NavigationContext } from '@layout/navigation/navigation';
import { useContext, useState } from 'react';
import { ReactComponent as AvatarPlaceholder } from '@assets/svg/avatar-placeholder.svg';
import { BrokenImageEnhanced } from '@components/BrokenImage/BrokenImageEnhanced';
import { ITooltip } from '@components/Tooltip';
import { useAuth0 } from '@auth0/auth0-react';
import MenuItem from './MenuItem';

interface AccountsSectionProps {
  className?: string;
}
const DisabledItem = 'Not available on mobile.';

function AccountsSection(props: AccountsSectionProps) {
  const back = () => {
    navigationState.navigationTab.set(initialNavigationState.navigationTab);
  };
  const { userName, userPicture, userEmail } = useContext(NavigationContext);
  const [tooltipId] = useState(`Not Editable Tooltip${Date.now()}`);
  const { logout } = useAuth0();
  return (
    <div {...props}>
      <div className="Heading">
        <BActionIcon icon="arrow-left" variant="transparent" onClick={back} />
        <Text text="p200" textColor="n600" className="AccountText">
          Account
        </Text>
      </div>
      <div className="ProfileSectionBorder">
        <div className="ProfileSection">
          <BrokenImageEnhanced
            className="Profile"
            src={userPicture}
            brokenSrc={<AvatarPlaceholder />}
          />
          <div className="NameAndEmail">
            <Text text="b200">{userName}</Text>
            <Text text="p100" textColor="n700">
              {userEmail}
            </Text>
          </div>
        </div>
      </div>
      <div className="OptionsSection">
        <div className="Options">
          <MenuItem
            title="Edit Profile"
            icon="edit"
            tooltipId={tooltipId}
            tooltipText={DisabledItem}
            disabled
          />
          <MenuItem
            title="Reset Password"
            icon="shield"
            tooltipId={tooltipId}
            tooltipText={DisabledItem}
            disabled
          />
          <MenuItem
            title="Personal Settings"
            icon="cog"
            tooltipId={tooltipId}
            tooltipText={DisabledItem}
            disabled
          />
          <ITooltip id={tooltipId} place="top" />
        </div>
        <MenuItem
          title="Sign out"
          icon="log-out"
          className="SignOut"
          onClick={logout}
        />
      </div>
    </div>
  );
}

export default styled(AccountsSection)`
  padding: 0 24px;

  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  row-gap: 16px;
  .Heading {
    display: grid;
    grid-template-columns: 32px 1fr 32px;
    width: 100%;
    align-items: center;

    color: var(--beam-color-neutral-n600);
    padding: 19px 0 7px;
  }
  .AccountText {
    text-align: center;
  }
  .Profile {
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }
  .ProfileSection {
    display: flex;
    align-items: center;
    padding: 8px 0px 8px 8px;
    gap: 10px;
    overflow: hidden;
  }
  .ProfileSectionBorder {
    padding-bottom: 16px;
    border-bottom: 1px solid var(--beam-color-neutral-n300);
  }
  .NameAndEmail {
    overflow: hidden;
  }
  .NameAndEmail > * {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .OptionsSection {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    row-gap: 4px;
  }
  .Options {
    flex-grow: 1;
    border-bottom: 1px solid var(--beam-color-neutral-n300);
    display: flex;
    flex-direction: column;
    row-gap: 4px;
  }
  .SignOut {
    padding-top: 16px;
    padding-bottom: 16px;
  }
`;
